// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__pcLQg","icon":"IconButton_icon__W7CT6","icon-dense":"IconButton_icon-dense__ripmP"};